import React from 'react';
import { DIGITAL_TRANSFORMATION } from '@/constants/content';

export const DigitalTransformation = () => {
  return (
    <section
      id="transformacion-digital"
      className="py-20 lg:py-32 bg-white"
      data-testid="digital-transformation-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="digital-transformation-title"
          >
            {DIGITAL_TRANSFORMATION.title}
          </h2>
          <p 
            className="text-base sm:text-lg text-gray-600 leading-relaxed"
            data-testid="digital-transformation-subtitle"
          >
            {DIGITAL_TRANSFORMATION.subtitle}
          </p>
        </div>

        {/* Blocks Container */}
        <div className="space-y-24 lg:space-y-32">
          {DIGITAL_TRANSFORMATION.blocks.map((block, index) => {
            const isImageRight = block.layout === 'image-right';
            
            return (
              <article
                key={block.id}
                className={`grid lg:grid-cols-2 gap-8 lg:gap-16 items-center ${
                  isImageRight ? '' : 'lg:grid-flow-dense'
                }`}
                data-testid={`transformation-block-${block.id}`}
              >
                {/* Text Content */}
                <div
                  className={`space-y-6 ${isImageRight ? 'lg:order-1' : 'lg:order-2'}`}
                  data-testid={`block-content-${block.id}`}
                >
                  {/* Block Title */}
                  <h3
                    className="text-3xl lg:text-4xl font-bold text-gray-900"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                    data-testid={`block-title-${block.id}`}
                  >
                    {block.title}
                  </h3>

                  {/* Block Subtitle */}
                  <p
                    className="text-xl font-semibold"
                    style={{ color: '#D7A22F' }}
                    data-testid={`block-subtitle-${block.id}`}
                  >
                    {block.subtitle}
                  </p>

                  {/* Block Description */}
                  <p
                    className="text-base sm:text-lg text-gray-600 leading-relaxed"
                    data-testid={`block-description-${block.id}`}
                  >
                    {block.description}
                  </p>

                  {/* Decorative Line */}
                  <div className="pt-4">
                    <div className="w-24 h-1 rounded-full" style={{ background: 'linear-gradient(to right, #1E40AF, #D7A22F)' }}></div>
                  </div>
                </div>

                {/* Image */}
                <div
                  className={`relative ${isImageRight ? 'lg:order-2' : 'lg:order-1'}`}
                  data-testid={`block-image-container-${block.id}`}
                >
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-200 hover:shadow-3xl transition-shadow duration-300">
                    <img
                      src={block.image}
                      alt={block.imageAlt}
                      className="w-full h-auto"
                      loading="lazy"
                      data-testid={`block-image-${block.id}`}
                    />
                  </div>

                  {/* Decorative Background Elements */}
                  <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full blur-3xl opacity-10 -z-10" style={{ backgroundColor: '#D7A22F' }}></div>
                  <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-blue-500 rounded-full blur-3xl opacity-10 -z-10"></div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
